import { make } from 'vuex-pathify'

const videoTokenPromises = new Map()
const videoTokens = new Map()

const savedSettings = typeof localStorage !== 'undefined' ? JSON.parse(localStorage.getItem('meeting.settingsv3')) : {}

const state = () => ({
  // Video call room
  room: null,
  isInCall: false,
  partnerWaiting: false,
  callJoined: false,
  isCameraEnabled: true,
  isMicrophoneEnabled: true,
  isRequestingAccess: false,
  complete: '',
  activeChatWindow: 'chat',
  settings: {
    viewMode: 'gallery',
    flipVideo: true,
    pipOnScreenShare: true,
    preferredVideoDevice: '',
    preferredAudioInput: '',
    videoBitrate: 1500000,
    CPUThreshold: 90,
    videoProcessor: false,
    ...savedSettings
  }
})

const getters = {
  booking (state, getters, rootState, rootGetters) {
    return rootGetters['myKintell/activeBooking']
  },
  user (state, getters, rootState, rootGetters) {
    return rootGetters['auth/user']
  },
  otherUser (state, getters) {
    const { booking, user } = getters
    return user.id === booking.advisor.id ? booking.learner : booking.advisor
  }
}

const actions = {
  getVideoToken ({ getters }) {
    const { booking } = getters

    if (videoTokens.has(booking.id)) { return videoTokens.get(booking.id) }

    if (videoTokenPromises.has(booking.id)) { return videoTokenPromises.get(booking.id) }

    const tokenPromise = (async () => {
      const response = await booking.fetchVideoToken()

      videoTokens.set(booking.id, response)
      return response
    })()

    videoTokenPromises.set(booking.id, tokenPromise)

    return tokenPromise
  },
  resetVideoTokens ({ state, commit, getters }) {
    videoTokenPromises.clear()
    videoTokens.clear()
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: make.mutations(state),
}
